import PlayerCard from './Playercard';

const AchievementPlayer = () => {
  return (
    <div >
      <PlayerCard name="Lionel Messi" imageUrl="https://example.com/messi.jpg" goals={35} />
      <PlayerCard name="Cristiano Ronaldo" imageUrl="https://example.com/ronaldo.jpg" goals={30} />
      <PlayerCard name="Neymar Jr" imageUrl="https://example.com/neymar.jpg" goals={25} />
    </div>
  );
};

export default AchievementPlayer;
